import React from 'react';
import { Divider as BaseDivider } from '@medicalwebexperts/ui';

const Divider = () => <BaseDivider my={8} />;

export default Divider;
